import { useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import {
  Dialog,
  DialogProps,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import { Button } from '../../../../../components/Button';
import { useActivity, IActivity } from '../../../hooks/activity';

interface IProps extends DialogProps {
  routeId: number;
  routeName: string;
  activity: IActivity;
  onClose: () => void;
}

export const CancelActivity = ({
  routeId,
  routeName,
  activity,
  onClose,
  ...props
}: IProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const { activityCanceled } = useActivity();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      await activityCanceled(routeId, activity.id, { images: [] }).then(() => {
        enqueueSnackbar('Entrega cancelada com sucesso!', {
          variant: 'success',
        });

        onClose();
      });
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  }, [activityCanceled, routeId, activity.id, enqueueSnackbar, onClose]);

  return (
    <Dialog
      maxWidth="sm"
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      {...props}
    >
      <DialogTitle id="confirmation-dialog-title">
        Cancelar atividade {activity.ordem} da {routeName}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          Deseja realmente cancelar esta atividade?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Fechar
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          loading={loading}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
